import '@/scss/app.scss';
import 'floating-vue/dist/style.css';
import '@/fabric/configureFabric';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { PiniaLogger } from 'pinia-logger';
import TooltipPlugin from 'floating-vue';
import * as Sentry from '@sentry/vue';
import App from '@/App.vue';
import { isDevOrDebug } from '@/config';

const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://5543313abaec2ec4a043dea805a66df5@o1150864.ingest.us.sentry.io/4511099914813440',
    debug: false,
    environment: import.meta.env.MODE,
    attachStacktrace: true,
    enableLogs: true,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    tracePropagationTargets: [
      /^\//,
    ],

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

const pinia = createPinia();

pinia.use(PiniaLogger({
  expanded: false,
  disabled: !isDevOrDebug,
}));

app.use(pinia);
app.use(TooltipPlugin, {
  distance: 9,
  skidding: 0,
  instantMove: true,
  themes: {
    tooltip: {
      placement: 'top',
      delay: {
        show: 250,
        hide: 80,
      },
    },
  },
});

app.mount('#app');
